import DemoAddressesTable from './DemoAddressesTable'

export default DemoAddressesTable
